import { createRouter, createWebHistory } from 'vue-router'
import guard from '@/router/guard'
import title from '@/router/title'
import routes from '@/router/routes'

const router = createRouter({
  history: createWebHistory('/'),
  routes,
  linkActiveClass: 'active',
})

// Global navigation guards
router.beforeEach(async (to, from, next) => {
  title(to, from) // Set the document.title or whatever it does
  await guard(to, from, next) // Only this one handles navigation
})

export default router
